import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { method } from "lodash";
import { actions, clearWorkbook, loadWorkbook } from "store/workbook/workbookSlice";
import axiosBaseQuery from "utils/axios/axiosBaseQuery";

export const workbookService = createApi({
  reducerPath: "workbookService",
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_VERSION,
  }),
  tagTypes: ["Workbooks", "GannWheelAspects"],
  endpoints: (builder) => ({
    getWorkbooks: builder.query({
      query: (payload) => {
        const queryString = new URLSearchParams(payload);
        return ({
          url: `/workbook?${queryString.toString()}`,
        })
      },
      providesTags: ["Workbooks"],
      transformResponse: (response) => response.data,
    }),
    getWorkbookById: builder.query({
      query: (id) => ({
        url: `/workbook/${id}`,
      }),
      providesTags: ["Workbook"],
      transformResponse: (response) => response.data,
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          let response = await queryFulfilled;
          dispatch(loadWorkbook(response?.data))
        } catch(err) {
          console.error("Failed to fetch workbook", err);
        }
      }
    }),
    saveWorkbook: builder.mutation({
      query: ({ _id, workbook }) => ({
        url: `/workbook/${_id}`,
        method: "PUT",
        data: workbook
      }),
    }),
    uploadWorkbook: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        Object.entries(data).map(([key, value]) => formData.append(key, value));
        return {
          url: "/workbook",
          method: "POST",
          data: formData,
          headers: { "content-type": "multipart/form-data" }
        }
      }
      // transformResponse: (response) => response.data,
    }),
    deleteWorkbook: builder.mutation({
      query: (id) => ({
        url: `/workbook/${id}`,
        method: "DELETE"
      }),
      invalidatesTags: ["Workbooks"],
      transformResponse: (response) => response.data,
    }),
  }),
});

export const {
  useGetWorkbooksQuery,
  useLazyGetWorkbooksQuery,
  useGetWorkbookByIdQuery,
  useLazyGetWorkbookByIdQuery,
  useUploadWorkbookMutation,
  useSaveWorkbookMutation,
  useDeleteWorkbookMutation,
} = workbookService;
